module.exports = __webpack_public_path__ + "static/media/Sparta-Leonidas.1a9acfbd.jpg";